import { useState } from 'react'
import Hero from '../components/Hero'
import './Careers.css'

const Careers = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    cv: null as File | null
  })

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.name === 'cv') {
      setFormData({
        ...formData,
        cv: e.target.files?.[0] || null
      })
    } else {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value
      })
    }
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    // Handle form submission here
    console.log('Career form submitted:', formData)
    // Reset form
    setFormData({ name: '', email: '', cv: null })
    alert('Thank you for your interest! We will review your application and get back to you soon.')
  }

  return (
    <>
      <Hero 
        title="Careers at Adept Services"
        subtitle="Join a diverse and inclusive workforce that is passionate about delivering high‑quality services and creating meaningful impact."
        backgroundImage="/careers/careers.png"
        height="55.78125vh"
      />

      <section>
        <div className="section-header">
          <h2>Expression of Interest</h2>
        </div>
        <p>We're always on the lookout for enthusiastic, motivated individuals to join our growing team. Please upload your CV and provide your contact details below. We value diversity and encourage applications from all backgrounds.</p>
        <form className="career-form" onSubmit={handleSubmit}>
          <input 
            type="text" 
            name="name" 
            placeholder="Your Name" 
            value={formData.name}
            onChange={handleChange}
            required 
          />
          <input 
            type="email" 
            name="email" 
            placeholder="Your Email" 
            value={formData.email}
            onChange={handleChange}
            required 
          />
          <input 
            type="file" 
            name="cv" 
            accept=".pdf,.doc,.docx" 
            onChange={handleChange}
            required 
          />
          <button type="submit">Submit</button>
        </form>
      </section>

      <section>
        <div className="section-header">
          <h2>Make an Impact</h2>
        </div>
        <p>We believe that every successful project creates new opportunities and strengthens connections within our communities. If you're driven by purpose and ready to make a meaningful impact, we'd love to hear from you.</p>
      </section>

      <section className="cta-section">
        <h2>Connect With Us Today</h2>
        <p>Whether you have questions about current openings or want to learn more about our culture, our team is ready to assist.</p>
        <a className="cta-button" href="/contact">Get in Touch</a>
      </section>
    </>
  )
}

export default Careers
